import { Box } from '@chakra-ui/react';
import styles from "../Common/Style/Style.module.css";
import { Navbar } from '../Common/Component/Navbar.component';
import { Login } from '../Common/Component/Login.component';
import { Footer } from '../Common/Component/Footer.component';

const CustomerLogin = () => {
    return (
        <Box className={styles.wrapper}>
            <Box className={styles.container}>
                <Navbar />
                <Login />
                <Footer />
            </Box>
        </Box>
    );
};

export default CustomerLogin;
